export default __webpack_public_path__ + "static/how-to-discover-your-perfect-winter-wonderland-new-york-b0bf202ede45d6354fc56c586565f1a1.jpg";